import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import {
  acceptFranchise,
  getFranchise,
  getFranchiseAccept,
  getFranchiseReject,
  hidefFranchise,
  nonAcceptFranchise,
  nonRejectFranchise,
  rejectFranchise,
} from "../../api/partners";
import { proxy } from "../../config";
import { Link } from "react-router-dom";
import { Cookies } from "react-cookie";

const RequestFranchisesComponent = (props) => {
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [acceptId, setAcceptId] = useState("");
  const [rejectId, setRejectId] = useState("");
  const [franchises, setFranchises] = useState(null);
  const [hideId, setHideId] = useState("");
  useEffect(() => {
    franchiseGet();
  }, []);

  const franchiseGet = () => {
    if (props.page === "new") {
      getFranchise().then((result) => {
        setFranchises(result.data.response);
      });
    } else if (props.page === "accept") {
      getFranchiseAccept().then((result) => {
        setFranchises(result.data.response);
      });
    } else {
      getFranchiseReject().then((result) => {
        setFranchises(result.data.response);
      });
    }
  };

  const hide = (id) => {
    hidefFranchise(id).then((result) => {
      franchiseGet();
      setHideId("");
    });
  };

  const accept = (id) => {
    acceptFranchise(id).then((result) => {
      setFranchises(franchises.filter((franchise) => franchise._id !== id));
    });
  };

  const nonAccept = (id) => {
    nonAcceptFranchise(id).then((result) => {
      setFranchises(franchises.filter((franchise) => franchise._id !== id));
    });
  };

  const reject = (id) => {
    rejectFranchise(id).then((result) => {
      setFranchises(franchises.filter((franchise) => franchise._id !== id));
    });
  };

  const nonReject = (id) => {
    nonRejectFranchise(id).then((result) => {
      setFranchises(franchises.filter((franchise) => franchise._id !== id));
    });
  };

  return (
    <>
      {franchises === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="card-cards">
            <div>Number of join us is {franchises.length}</div>

            {franchises?.map((franchise) => (
              <div key={franchise._id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <img
                      className="image-slider"
                      height={"100px"}
                      src={`${proxy}/${franchise.image}`}
                    />
                    <p className="line">
                      <span className="label">Name:</span> {franchise.name}
                    </p>
                    <p className="line">
                      <span className="label">Phone:</span> {franchise.phone}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {franchise?.createdAt.split("T")[0]}
                    </p>
                    <p className="line">
                      <span className="label">Description:</span>{" "}
                      {franchise.description}
                    </p>
                    <p className="line">
                      <span className="label">Location:</span>{" "}
                      <Link target="_blank" to={franchise.location}>
                        Click here
                      </Link>
                    </p>
                    {rejectId === franchise._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to reject this franchise?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setRejectId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                reject(franchise._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {acceptId === franchise._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to accept this franchise?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setAcceptId("");
                              }}
                              className="action-btn remove-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                accept(franchise._id);
                              }}
                              className="action-btn accept-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    {hideId === franchise._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setHideId("");
                              }}
                              className="action-btn remove-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                hide(franchise._id);
                              }}
                              className="action-btn accept-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div>
                  {isSuper && (
                    <>
                      {props.page === "new" && (
                        <div className="card-actions">
                          <>
                            {acceptId !== franchise._id &&
                              rejectId !== franchise._id && (
                                <div className="card-actions">
                                  <button
                                    onClick={() => {
                                      setRejectId(franchise._id);
                                    }}
                                    className="action-btn remove-btn"
                                  >
                                    Reject
                                  </button>
                                  <button
                                    onClick={() => {
                                      setAcceptId(franchise._id);
                                    }}
                                    className="action-btn accept-btn"
                                  >
                                    Accept
                                  </button>
                                </div>
                              )}
                          </>
                        </div>
                      )}
                    </>
                  )}
                  <div style={{ height: "10px" }}></div>
                  {isSuper &&
                    hideId === "" &&
                    (props.page === "accept" || props.page === "reject") && (
                      <button
                        onClick={() => {
                          setHideId(franchise._id);
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete
                      </button>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default RequestFranchisesComponent;
